
import { UseFormReturn } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { ProcurementFormValues } from "../../schema";

interface CostInputFieldsProps {
  form: UseFormReturn<ProcurementFormValues>;
}

export const CostInputFields = ({ form }: CostInputFieldsProps) => {
  const handleNumberChange = (field: any, value: string, fieldName: keyof ProcurementFormValues) => {
    const numValue = parseFloat(value) || 0;
    field.onChange(numValue);
    
    // Trigger form validation to ensure watchers are notified
    form.trigger(fieldName);
    
    // Force a form state update to ensure calculations are triggered
    setTimeout(() => {
      form.trigger();
    }, 0);
  };

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <FormField
        control={form.control}
        name="transport_cost_per_unit"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Transport Cost</FormLabel>
            <FormControl>
              <Input
                type="number"
                step="0.01"
                placeholder="0.00"
                className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [-moz-appearance:textfield]"
                {...field}
                onChange={e => handleNumberChange(field, e.target.value, "transport_cost_per_unit")}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="loading_unloading_cost_per_unit"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Loading/Unloading Cost</FormLabel>
            <FormControl>
              <Input
                type="number"
                step="0.01"
                placeholder="0.00"
                className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [-moz-appearance:textfield]"
                {...field}
                onChange={e => handleNumberChange(field, e.target.value, "loading_unloading_cost_per_unit")}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="agent_cost_per_unit"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Agent Commission</FormLabel>
            <FormControl>
              <Input
                type="number"
                step="0.01"
                placeholder="0.00"
                className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [-moz-appearance:textfield]"
                {...field}
                onChange={e => handleNumberChange(field, e.target.value, "agent_cost_per_unit")}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="other_cost_per_unit"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Other Costs</FormLabel>
            <FormControl>
              <Input
                type="number"
                step="0.01"
                placeholder="0.00"
                className="[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [-moz-appearance:textfield]"
                {...field}
                onChange={e => handleNumberChange(field, e.target.value, "other_cost_per_unit")}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
